import { MutationTree } from 'vuex'
import { IAuthorizationState } from './authorization-state.store';
import {
  AUTHORIZATION_STATUS, AUTHORIZATION_AUTHORIZE_SUCCESS, AUTHORIZATION_SIGN_IN, AUTHORIZATION_SIGN_IN_FAILED, AUTHORIZATION_SIGN_IN_LOADING
} from './authorization-types.store';
import { ActivityStatus } from '../../common/enums';

export const mutations: MutationTree<IAuthorizationState> = {
  [AUTHORIZATION_STATUS]: (state: IAuthorizationState, payload: ActivityStatus) => {
    state.activityStatus = payload;
  }
  , [AUTHORIZATION_AUTHORIZE_SUCCESS]: (state: IAuthorizationState, isAuthorized: boolean) => {
    state.isAuthorized = isAuthorized;
  }
  , [AUTHORIZATION_SIGN_IN]: (state: IAuthorizationState, response: { accessToken: string }) => {
    state.signInPayload.accessToken = response.accessToken;
    state.signInPayload.error = null;
    state.signInPayload.activityStatus = ActivityStatus.Loaded;
  }
  , [AUTHORIZATION_SIGN_IN_FAILED]: (state: IAuthorizationState, error: any) => {
    state.signInPayload.accessToken = null;
    state.signInPayload.error = error;
    state.signInPayload.activityStatus = ActivityStatus.LoadFailed;
  }
  , [AUTHORIZATION_SIGN_IN_LOADING]: (state: IAuthorizationState, error: any) => {

    state.signInPayload.error = null;
    state.signInPayload.activityStatus = ActivityStatus.Loading;
  }
}


// WEBPACK FOOTER //
// ./src/store/authorization/authorization-mutations.store.ts